module.exports = __webpack_public_path__ + "static/media/Discovery-Insight.23196740.svg";